/** Small helpers shared by the API and all three portals. */
export function initials(name) {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0)
        return '?';
    if (parts.length === 1)
        return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
/** Org codes are uppercase, alphanumeric, and appear in report filenames. */
export function toOrgCode(name) {
    return name
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '')
        .slice(0, 12);
}
export function truncate(value, max) {
    return value.length <= max ? value : `${value.slice(0, max - 1)}…`;
}
/** Upload filenames are sanitised and never used as a storage path. */
export function safeFileName(name) {
    return name
        .replace(/[/\\?%*:|"<>]/g, '-')
        .replace(/\s+/g, '_')
        .slice(0, 180);
}
export function pluralise(count, singular, plural = `${singular}s`) {
    return `${count} ${count === 1 ? singular : plural}`;
}
/** Case-insensitive, whitespace-tolerant comparison for CSV column mapping. */
export function loosely(a, b) {
    return a.trim().toLowerCase().replace(/[\s_-]+/g, '') === b.trim().toLowerCase().replace(/[\s_-]+/g, '');
}
//# sourceMappingURL=text.js.map